(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-colour-current"] && !Shopify.designMode) return;
  try {
    
  class PerfectPatchesColourCurrent extends HTMLElement {
    connectedCallback() {
      const native = typeof CSS !== 'undefined' && CSS.supports('animation-timeline', 'view()');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (native || this.motion.matches || !('IntersectionObserver' in window)) return;
      this.measure = this.measure.bind(this);
      this.queue = this.queue.bind(this);
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.start();
        else this.stop();
      }, { rootMargin: '100% 0px' });
      this.dataset.ppColourJs = 'true';
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
    }

    start() {
      if (this.listening) return;
      this.listening = true;
      window.addEventListener('scroll', this.queue, { passive: true });
      window.addEventListener('resize', this.queue, { passive: true });
      this.measure();
    }

    stop() {
      if (!this.listening) return;
      this.listening = false;
      window.removeEventListener('scroll', this.queue);
      window.removeEventListener('resize', this.queue);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    queue() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(this.measure);
    }

    measure() {
      this.frame = 0;
      if (this.motion.matches) return this.stop();
      const rect = this.getBoundingClientRect();
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      const raw = (viewport - rect.top) / (viewport + rect.height);
      const progress = Math.round(Math.min(Math.max(raw, 0), 1) * 1000) / 1000;
      if (progress === this.progress) return;
      this.progress = progress;
      this.style.setProperty('--pp-colour-progress', String(progress));
    }
  }

  if (!customElements.get('pp-colour-current')) {
    customElements.define('pp-colour-current', PerfectPatchesColourCurrent);
  }

  } catch(e) { console.error(e); }
})();
})();
